import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Permission required to access the Claude Usage plugin.
 */
export const claudeUsageAccessPermission = createPermission({
  name: 'claude.usage.access',
  attributes: {
    action: 'read',
  },
});

/**
 * All Claude Usage permissions.
 */
export const claudeUsagePermissions = [claudeUsageAccessPermission];
